import React from 'react';
import classNames from 'classnames';
import { IconType } from 'react-icons';

/**
 * 캔버스 오른쪽 위 도구 모음의 아이콘 버튼 — 워크플로 동작(되돌리기~실행)과 파일 동작(내려받기·불러오기·그림)이
 * 같은 모양을 쓴다. 이름은 title(툴팁)에 담는다.
 */
export interface ToolbarButtonProps {
  onClick: () => void;
  title: string;
  icon: IconType;
  /** 아이콘 색 (text-*) */
  className?: string;
  disabled?: boolean;
  /** 아이콘 오른쪽 위의 작은 표시 — 버전 번호, 미저장 점, 수정본 표시 등 */
  badge?: React.ReactNode;
  /** 누른 상태로 보이기 (실행 중 등) */
  active?: boolean;
  spin?: boolean;
  /** 도움말·AI 가 가리킬 때 쓰는 키 (help/pointer — 예: toolbar:save) */
  point?: string;
}

const ToolbarButton: React.FC<ToolbarButtonProps> = ({ onClick, title, icon: Icon, className, disabled, badge, active, spin, point }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    title={title}
    aria-label={title}
    data-point={point}
    className={classNames(
      'relative p-2 rounded-lg transition-colors disabled:opacity-35 disabled:cursor-not-allowed',
      active ? 'bg-gray-100' : 'hover:bg-gray-100',
    )}
  >
    {/* @ts-ignore react-icons IconType 과 React 18 타입 불일치 회피 */}
    <Icon size={22} className={classNames(className, spin && 'animate-spin')} />
    {badge != null && badge !== false && (
      <span className="absolute -top-0.5 -right-0.5 pointer-events-none">{badge}</span>
    )}
  </button>
);

/** 도구 모음 안의 묶음 구분선 */
export const ToolbarDivider: React.FC = () => <span className="self-stretch w-px my-1 bg-gray-200" aria-hidden />;

export default ToolbarButton;
